import { Card, CardBody, CardHeader, Col, Container, Row, Table, } from "reactstrap";
import { Image, Badges, Btn } from "../../AbstractElements";
import { URL_API } from "../../utils/helper/helpers";
import Breadcrumbs from "../../CommonElements/Breadcrumbs/Breadcrumbs";
import { useCallback, useEffect, useRef, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { formatPhoneNumber, formatPrice, generateRandomNumber, numberToWords } from "../../utils/helper/helpers";

import { Link, useParams } from "react-router-dom";
import html2pdf from "html2pdf.js";

// Types
type Carburants = { [key: string]: any }

const ShowCarburant = () => {

    const [carburant, setCarburant] = useState<Carburants | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [refresh, setRefresh] = useState(false);
    const params = useParams();
    const Token = JSON.parse(localStorage.getItem("login")!);

    // Fetch data from API
    const fetchCarburant = useCallback(async () => {
        try {
            const response = await axios.get(`${URL_API}/carburant/show/${params.id}`, {
                headers: { Authorization: `Bearer ${Token}` }
            });
            if (response.status === 200) {
                setCarburant(response.data.carburant);

            }
        } catch (error: any) {
            const message = error.response?.data?.message || "Erreur inconnue";
            toast.error(message);
        }
    }, []);

    // Initial data fetch
    useEffect(() => {
        fetchCarburant();
        setTimeout(() => {
            if ( carburant && carburant?.length > 0) {
                setIsLoading(false); // Les données sont chargées, on arrête le loader
              } else {
                setIsLoading(false);
              }
          }, 2000);
    }, [refresh, fetchCarburant]);

    const documentContent = (
        <>
            <h2>Mon Document PDF</h2>
            <p>Ceci est un exemple de document PDF généré avec React et html2pdf.js.</p>
            {/* Ajoutez plus de contenu ici selon vos besoins */}
        </>
    );

    const pdfRef = useRef<HTMLDivElement>(null);

    const generatePDF = () => {
        const element = pdfRef.current;
        const name_document = generateRandomNumber(100000, 999999);
        if (element) {
            html2pdf()
                .from(element)
                .save(`bon_carburant_${name_document}.pdf`);
        }
    };


    return (
        <div className='page-body'>
            {isLoading ? (
                <div className="loading-container">
                    <div className="spinner-container">
                        <div className="spinner"></div>
                        <span className="loading-text">Chargement de la plateforme...</span>
                    </div>
                </div>
            ) : ( 
                <>
                    <Breadcrumbs mainTitle="Carburant Details" parent="Carburant" />
                    <Container fluid>
                        <Card>
                            <CardBody>
                                <div ref={pdfRef}>
                                    <div className="text-center mb-5 mt-5">
                                        <p dangerouslySetInnerHTML={{ __html: carburant?.ets_description }}></p>

                                    </div>
                                    <h2 className="fw-bold text-center"> BON DE CARBURANT</h2>
                                    <Row className="mx-3 my-4">
                                        <Col lg={6}>
                                            <p className="f-18"><span className="fw-bold">Nom </span> : {carburant?.ets_nom}</p>
                                            <p className="f-18"><span className="fw-bold">Tel </span>: {formatPhoneNumber(carburant?.ets_telephone)}</p>
                                            <p className="f-18"><span className="fw-bold">Adresse </span>: {carburant?.ets_adresse}</p>
                                        </Col>
                                        <Col lg={6} className="text-center">
                                            <h2 className=" fw-lighter f-18"> Date d'Émission</h2>
                                            {
                                                carburant?.status === "payed" ? (
                                                    <h3 className="text-success my-2 f-18 fw-lighter text-uppercase" style={{ fontFamily: 'Courier' }}>{carburant?.date_carburant}</h3>
                                                ) : (
                                                    <h3 className="text-danger my-2 f-18 fw-lighter text-uppercase" style={{ fontFamily: 'Courier' }}>{carburant?.date_carburant}</h3>

                                                )
                                            }
                                        </Col>

                                    </Row>
                                    <div className="mx-3 mt-5">
                                        <Table bordered responsive className="text-center">
                                            <thead>
                                                <tr className="f-18">
                                                    <th scope="col">IMMATRICULATION</th>
                                                    <th scope="col">DESIGNATION</th>
                                                    <th scope="col">QUANTITE LITRE</th>
                                                    <th scope="col">MONTANT</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr className="f-18">
                                                    <td>{carburant?.immatriculation}</td>
                                                    <td>{carburant?.designation}</td>
                                                    <td>{parseInt(carburant?.quantite_litre).toLocaleString("gn-GN")} L</td>
                                                    <td>{formatPrice(carburant?.montant)}</td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                        <div className="text-end my-4" >
                                            <p className="f-17"> Reçu par : <span className="fw-bold">{carburant?.recever}</span></p>

                                            {
                                                carburant?.users_signature
                                                    ? (<Image src={carburant.users_signature} alt="User signature" />)
                                                    : (null)
                                            }
                                            <p className="f-17"> Enrégistré par : <span className="fw-bold">{carburant?.user_name + " " + carburant?.user_firstname}</span></p>
                                            <p className="f-17"> Téléphone : <span className="fw-bold">{formatPhoneNumber(carburant?.user_phone)}</span></p>
                                        </div>
                                    </div>
                                </div>

                                <div className="text-end">
                                    <Btn color="light-info " onClick={generatePDF} className="btn btn-xs mx-1 p-1 px-3">
                                        <i className="fa fa-download"></i> Télécharger
                                    </Btn>
                                    <Link to="/bon-de-carburant" className="btn btn-xs mx-1 p-1 px-3 btn-light-danger">
                                        <i className="fa fa-sign-out"></i> Quitter
                                    </Link>
                                </div>
                            </CardBody>
                        </Card>
                    </Container>
                </>
            )}
            
        </div >

    )
}

export default ShowCarburant;